var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMarkerHavenueOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 56,
  viewBox: "0 0 34 56"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "outline",
  fillRule: "nonzero",
  stroke: "#F8E71C",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M22.73 31.943 17.055 46.6 11.4 31.993A16.01 16.01 0 0 1 1 17C1 8.163 8.163 1 17 1s16 7.163 16 16c0 6.66-4.12 12.588-10.27 14.943z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#231F20",
  stroke: "#000",
  d: "M12.55 30.804A14.51 14.51 0 0 1 2.5 17C2.5 8.992 8.992 2.5 17 2.5S31.5 8.992 31.5 17a14.51 14.51 0 0 1-9.922 13.762l-4.522 11.682-4.507-11.64z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#808184",
  d: "M15.83 22.008c-.003 1.295-.818 1.504-1.41 1.504v.157h5.159v-.157c-.591 0-1.407-.209-1.408-1.504v-3.471h-2.34zm2.341-9.347v3.473h-2.34V12.66c-.004-1.295-.819-1.505-1.411-1.505V11h5.159v.156c-.591 0-1.407.21-1.408 1.505"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M24.59 12.66c.002-1.294.819-1.504 1.41-1.504V11h-5.16v.156c.593 0 1.41.21 1.41 1.505v9.347c0 1.296-.817 1.504-1.41 1.504v.156H26v-.156c-.591 0-1.408-.208-1.41-1.504zm-12.84 9.348c.003 1.296.82 1.504 1.41 1.504v.156H8v-.156c.591 0 1.408-.208 1.408-1.504V12.66c0-1.295-.817-1.505-1.408-1.505V11h5.161v.156c-.592 0-1.408.21-1.41 1.505z"
}))));
export default SvgMarkerHavenueOn;